import { dateFormatter } from "src/utils/helperFunctions";
import { Button } from "flowbite-react";

interface Props {
  data: any;
}

const BlogDetails = ({ data }: Props) => {
  return (
    <div>
      <p className="mt-4 mb-3 text-4xl font-semibold leading-9 text-center dark:text-dark-text-primary ">
        {data.title}
      </p>
      <div className="mb-4 text-xs text-center text-gray-500 dark:text-dark-text-primary">
        <span className="mr-2 uppercase dark:text-dark-text-secondary ">
          {data.author}
        </span>
        |
        <span className="mx-2 uppercase dark:text-dark-text-secondary">
          {data.minute_read} min read
        </span>
        |
        <span className="ml-2 uppercase dark:text-dark-text-secondary ">
          {dateFormatter(new Date(data.published_date), "d m y")}
        </span>
      </div>
      <div className="blog-details">
        <div dangerouslySetInnerHTML={{ __html: data.description || "" }} />
      </div>
      <div className="flex gap-2 mt-2 mb-2 dark:text-dark-text-secondary">
        <p className="m-0 font-semibold dark:text-dark-text-secondary">Tags:</p>
        <div className="text-gray-600 dark:text-dark-text-secondary">
          {data?.tags?.join(",")}
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
